module.exports = __webpack_public_path__ + "img/fantasy-football-btn-icon.c193775b.png";